/**
 * Amount in the Serbian format the accountants read (1.234.567,89).
 *
 * @param {number} value - Amount
 * @returns {string} Formatted amount
 */
export const formatAmount = (value) =>
  Number(value || 0).toLocaleString('sr-RS', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/**
 * Exchange rate in the same format, to four decimals (117,3531).
 *
 * @param {number|null} value - Rate
 * @returns {string} Formatted rate, or a dash when there is none
 */
export const formatRate = (value) =>
  value == null
    ? '—'
    : Number(value).toLocaleString('sr-RS', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });

/**
 * Hand a downloaded file to the browser.
 *
 * @param {Object} file - { blob, fileName }
 */
export const saveBlob = ({ blob, fileName }) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * The server's message out of a failed request, also when the response was
 * asked for as a blob (downloads carry their JSON error as a blob).
 *
 * @param {Error} error - Axios error
 * @returns {Promise<string>} The message to show
 */
export const errorText = async (error) => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const body = JSON.parse(await data.text());
      return body.message || body.error || error.message;
    } catch {
      return error.message;
    }
  }
  return data?.message || data?.error || error?.message;
};

/**
 * A pack file's name as the pack settings show it: its title, or its type.
 *
 * @param {Object} report - Pack report row
 * @returns {string} The file title
 */
export const fileTitle = (report) => report.title || report.type;
